<template>
  <div>
    <div v-if="uploadList.length" class="demo-upload-list" v-for="(item,index) in uploadList">
        <template v-if="item.status === 'finished'">
            <img :src="$global.imgUrl+item.url">
            <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(index)"></Icon>
            </div>
        </template>
        <template v-else>
            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
        </template>
    </div>
    <Upload
        ref="upload"
        :show-upload-list="false"
        :on-success="handleSuccess"
        :format="['jpg','jpeg','png']"
        accept=".jpg,.jpeg,.png"
        :max-size="2048"
        :on-format-error="handleFormatError"
        :on-exceeded-size="handleMaxSize"
        :before-upload="handleBeforeUpload"
        multiple
        type="drag"
        :action="$global.url+'/sys/common/upload'"
        style="display: inline-block;width:58px;">
        <div style="width: 58px;height:58px;line-height: 58px;">
            <Icon type="ios-camera" size="20"></Icon>
        </div>
    </Upload>
    <Modal title="查看图片" v-model="visible">
        <img :src="$global.imgUrl+imgName" v-if="visible" style="width: 100%">
    </Modal>
  </div>
</template>
<script>

    export default {
        props:['imgList','max','name'],
        data () {
            return {
                imgName: '',
                visible: false,
                uploadList: [],
            }
        },
        mounted(){
          if(this.imgList){

            setTimeout(() => {
              this.uploadList=this.imgList.map(item=>{
                   return {url:item.imgPath,status:"finished"}
              });
              this.commit();
            }, 500);
          }
        },
        methods: {
            commit(){
              let arr=""
              if(this.uploadList.length){
                arr=this.uploadList.map(item=>{
                  return item.url;
                }).join(",");
              }
              this.$emit('fun',{'name':this.name,'url':arr})
            },
            handleView (name) {
                this.visible = true;
                this.imgName=name;
            },
            handleRemove (file) {
                this.uploadList.splice(file, 1);
                this.commit();
            },
            handleSuccess (res, file) {
              if(res.resultCode==0){
                this.uploadList.push({url:res.content.url,status:"finished"})
                this.commit();
              }
            },
            handleFormatError (file) {
                this.$Message.destroy()
                this.$Message.warning(`请上传图片格式的文件！`);
            },
            handleMaxSize (file) {
                this.$Message.destroy()
                this.$Message.warning(`图片太大，最多可上传2M!`);
            },
            handleBeforeUpload () {
                const check = this.uploadList.length < this.max;
                if (!check) {
                    this.$Message.destroy()
                    this.$Message.warning(`最多可上传${this.max}张!`);
                }
                return check;
            }
        },
    }
</script>
<style>
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>



// WEBPACK FOOTER //
// src/components/upload.vue